import { Info } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/components/info/info";

import { AdditionalServices } from "./components/additionalServices/additionalServices";
import { ClickAndCollect } from "./components/clickAndCollect/clickAndCollect";
import { HomeDelivery } from "./components/homeDelivery/homeDelivery";
import { DeliveryItemBase } from "./deliveryItem.base";

export const DeliveryItem = Object.assign(DeliveryItemBase, {
    Info: Info,
    HomeDelivery: HomeDelivery,
    ClickAndCollect: ClickAndCollect,
    AdditionalServices: AdditionalServices
});
